// extracted by mini-css-extract-plugin
export var MigrationHero = "MigrationHero-module--MigrationHero--OucHp";
export var MigrationHero_actions = "MigrationHero-module--MigrationHero_actions--0aoxW";
export var MigrationHero_actions_btn = "MigrationHero-module--MigrationHero_actions_btn--4Uw7k";
export var MigrationHero_body = "MigrationHero-module--MigrationHero_body--FSzO6";
export var MigrationHero_container = "MigrationHero-module--MigrationHero_container--TEjIP";
export var MigrationHero_content = "MigrationHero-module--MigrationHero_content--gwDdZ";
export var MigrationHero_eyebrow = "MigrationHero-module--MigrationHero_eyebrow--CsUE5";
export var MigrationHero_footnote = "MigrationHero-module--MigrationHero_footnote--NT5uy";
export var MigrationHero_header = "MigrationHero-module--MigrationHero_header--8Ob94";
export var MigrationHero_image = "MigrationHero-module--MigrationHero_image--LIl5F";
export var MigrationHero_title = "MigrationHero-module--MigrationHero_title--4VhsZ";
export var container = "MigrationHero-module--container--MN2r1";
export var gatsbyImageWrapperConstrained = "MigrationHero-module--gatsby-image-wrapper-constrained--bMxx6";
export var gridSpan1010 = "MigrationHero-module--grid-span-10-10--pnj5M";
export var gridSpan1011 = "MigrationHero-module--grid-span-10-11--C9lUN";
export var gridSpan102 = "MigrationHero-module--grid-span-10-2--vkbBD";
export var gridSpan103 = "MigrationHero-module--grid-span-10-3--ydmuY";
export var gridSpan104 = "MigrationHero-module--grid-span-10-4--OP75k";
export var gridSpan105 = "MigrationHero-module--grid-span-10-5--AU5Ir";
export var gridSpan106 = "MigrationHero-module--grid-span-10-6--XMmLL";
export var gridSpan107 = "MigrationHero-module--grid-span-10-7--mRSNU";
export var gridSpan108 = "MigrationHero-module--grid-span-10-8--MoB4l";
export var gridSpan109 = "MigrationHero-module--grid-span-10-9--PLsoJ";
export var gridSpan110 = "MigrationHero-module--grid-span-1-10--vAZ7y";
export var gridSpan111 = "MigrationHero-module--grid-span-1-11--GqQ3n";
export var gridSpan1110 = "MigrationHero-module--grid-span-11-10--UTyAS";
export var gridSpan1111 = "MigrationHero-module--grid-span-11-11--UWX8A";
export var gridSpan112 = "MigrationHero-module--grid-span-11-2--vCbiX";
export var gridSpan113 = "MigrationHero-module--grid-span-11-3--R1BV-";
export var gridSpan114 = "MigrationHero-module--grid-span-11-4--NTMwn";
export var gridSpan115 = "MigrationHero-module--grid-span-11-5---gBR+";
export var gridSpan116 = "MigrationHero-module--grid-span-11-6--kG9M4";
export var gridSpan117 = "MigrationHero-module--grid-span-11-7--3DvJc";
export var gridSpan118 = "MigrationHero-module--grid-span-11-8--g0HuH";
export var gridSpan119 = "MigrationHero-module--grid-span-11-9--B7KKF";
export var gridSpan12 = "MigrationHero-module--grid-span-1-2--GPuUl";
export var gridSpan1210 = "MigrationHero-module--grid-span-12-10--jT8Ui";
export var gridSpan1211 = "MigrationHero-module--grid-span-12-11--5sLOp";
export var gridSpan122 = "MigrationHero-module--grid-span-12-2--tVxJk";
export var gridSpan123 = "MigrationHero-module--grid-span-12-3--ywvy1";
export var gridSpan124 = "MigrationHero-module--grid-span-12-4--FyWaD";
export var gridSpan125 = "MigrationHero-module--grid-span-12-5--yCo1s";
export var gridSpan126 = "MigrationHero-module--grid-span-12-6--ZSeVz";
export var gridSpan127 = "MigrationHero-module--grid-span-12-7--gZoNQ";
export var gridSpan128 = "MigrationHero-module--grid-span-12-8--6XcdH";
export var gridSpan129 = "MigrationHero-module--grid-span-12-9--479uz";
export var gridSpan13 = "MigrationHero-module--grid-span-1-3--3r5Zd";
export var gridSpan14 = "MigrationHero-module--grid-span-1-4--O5uYA";
export var gridSpan15 = "MigrationHero-module--grid-span-1-5--RJR-8";
export var gridSpan16 = "MigrationHero-module--grid-span-1-6--H0Gag";
export var gridSpan17 = "MigrationHero-module--grid-span-1-7--6ZX97";
export var gridSpan18 = "MigrationHero-module--grid-span-1-8--rOjqu";
export var gridSpan19 = "MigrationHero-module--grid-span-1-9--2AF52";
export var gridSpan210 = "MigrationHero-module--grid-span-2-10--Z1jIY";
export var gridSpan211 = "MigrationHero-module--grid-span-2-11--K08RC";
export var gridSpan22 = "MigrationHero-module--grid-span-2-2--C7meP";
export var gridSpan23 = "MigrationHero-module--grid-span-2-3--WZ3ma";
export var gridSpan24 = "MigrationHero-module--grid-span-2-4--JWJjb";
export var gridSpan25 = "MigrationHero-module--grid-span-2-5--M2rZq";
export var gridSpan26 = "MigrationHero-module--grid-span-2-6--ywo8J";
export var gridSpan27 = "MigrationHero-module--grid-span-2-7--oiRdr";
export var gridSpan28 = "MigrationHero-module--grid-span-2-8--1-9C8";
export var gridSpan29 = "MigrationHero-module--grid-span-2-9--LoLrI";
export var gridSpan310 = "MigrationHero-module--grid-span-3-10--Ylhl3";
export var gridSpan311 = "MigrationHero-module--grid-span-3-11--UiF8K";
export var gridSpan32 = "MigrationHero-module--grid-span-3-2--REYpb";
export var gridSpan33 = "MigrationHero-module--grid-span-3-3--G75pV";
export var gridSpan34 = "MigrationHero-module--grid-span-3-4--o2ErU";
export var gridSpan35 = "MigrationHero-module--grid-span-3-5--Mm1Z+";
export var gridSpan36 = "MigrationHero-module--grid-span-3-6--83iv2";
export var gridSpan37 = "MigrationHero-module--grid-span-3-7--8qMF7";
export var gridSpan38 = "MigrationHero-module--grid-span-3-8--c-gwP";
export var gridSpan39 = "MigrationHero-module--grid-span-3-9--w3jS8";
export var gridSpan410 = "MigrationHero-module--grid-span-4-10--XTlTf";
export var gridSpan411 = "MigrationHero-module--grid-span-4-11--edP+V";
export var gridSpan42 = "MigrationHero-module--grid-span-4-2--M87tf";
export var gridSpan43 = "MigrationHero-module--grid-span-4-3--fcHAL";
export var gridSpan44 = "MigrationHero-module--grid-span-4-4--i5uta";
export var gridSpan45 = "MigrationHero-module--grid-span-4-5--Jj1BK";
export var gridSpan46 = "MigrationHero-module--grid-span-4-6--jWp7Q";
export var gridSpan47 = "MigrationHero-module--grid-span-4-7--249uK";
export var gridSpan48 = "MigrationHero-module--grid-span-4-8--zea4D";
export var gridSpan49 = "MigrationHero-module--grid-span-4-9--qhZki";
export var gridSpan510 = "MigrationHero-module--grid-span-5-10--2IzZ2";
export var gridSpan511 = "MigrationHero-module--grid-span-5-11--BBTvI";
export var gridSpan52 = "MigrationHero-module--grid-span-5-2--eXKo7";
export var gridSpan53 = "MigrationHero-module--grid-span-5-3--lfOQt";
export var gridSpan54 = "MigrationHero-module--grid-span-5-4--E5y8c";
export var gridSpan55 = "MigrationHero-module--grid-span-5-5--B6It6";
export var gridSpan56 = "MigrationHero-module--grid-span-5-6--nF83O";
export var gridSpan57 = "MigrationHero-module--grid-span-5-7--Nhhhd";
export var gridSpan58 = "MigrationHero-module--grid-span-5-8--909Rw";
export var gridSpan59 = "MigrationHero-module--grid-span-5-9--jiL7+";
export var gridSpan610 = "MigrationHero-module--grid-span-6-10--ZMzdo";
export var gridSpan611 = "MigrationHero-module--grid-span-6-11--lv8qH";
export var gridSpan62 = "MigrationHero-module--grid-span-6-2--xPias";
export var gridSpan63 = "MigrationHero-module--grid-span-6-3--qfS3h";
export var gridSpan64 = "MigrationHero-module--grid-span-6-4--pdMOp";
export var gridSpan65 = "MigrationHero-module--grid-span-6-5--ftmZG";
export var gridSpan66 = "MigrationHero-module--grid-span-6-6--omdmM";
export var gridSpan67 = "MigrationHero-module--grid-span-6-7--+Ajkd";
export var gridSpan68 = "MigrationHero-module--grid-span-6-8--BokIB";
export var gridSpan69 = "MigrationHero-module--grid-span-6-9--PEuO5";
export var gridSpan710 = "MigrationHero-module--grid-span-7-10--RXQIc";
export var gridSpan711 = "MigrationHero-module--grid-span-7-11--t+G4X";
export var gridSpan72 = "MigrationHero-module--grid-span-7-2--iXrdi";
export var gridSpan73 = "MigrationHero-module--grid-span-7-3--bun2v";
export var gridSpan74 = "MigrationHero-module--grid-span-7-4--KVajb";
export var gridSpan75 = "MigrationHero-module--grid-span-7-5--tIlsI";
export var gridSpan76 = "MigrationHero-module--grid-span-7-6--vPN27";
export var gridSpan77 = "MigrationHero-module--grid-span-7-7--S4opA";
export var gridSpan78 = "MigrationHero-module--grid-span-7-8--7P2Ey";
export var gridSpan79 = "MigrationHero-module--grid-span-7-9--s+j-q";
export var gridSpan810 = "MigrationHero-module--grid-span-8-10--VxOCA";
export var gridSpan811 = "MigrationHero-module--grid-span-8-11--uLv3+";
export var gridSpan82 = "MigrationHero-module--grid-span-8-2--4knAn";
export var gridSpan83 = "MigrationHero-module--grid-span-8-3--jxtv4";
export var gridSpan84 = "MigrationHero-module--grid-span-8-4--Q-e7I";
export var gridSpan85 = "MigrationHero-module--grid-span-8-5--r-bDn";
export var gridSpan86 = "MigrationHero-module--grid-span-8-6--Y4VQY";
export var gridSpan87 = "MigrationHero-module--grid-span-8-7--DdiP1";
export var gridSpan88 = "MigrationHero-module--grid-span-8-8--ftGZy";
export var gridSpan89 = "MigrationHero-module--grid-span-8-9--hHG53";
export var gridSpan910 = "MigrationHero-module--grid-span-9-10--R6Y4p";
export var gridSpan911 = "MigrationHero-module--grid-span-9-11--GoaxS";
export var gridSpan92 = "MigrationHero-module--grid-span-9-2--DL67K";
export var gridSpan93 = "MigrationHero-module--grid-span-9-3--2-ORV";
export var gridSpan94 = "MigrationHero-module--grid-span-9-4--XzcyD";
export var gridSpan95 = "MigrationHero-module--grid-span-9-5--BlOKt";
export var gridSpan96 = "MigrationHero-module--grid-span-9-6--GwpSN";
export var gridSpan97 = "MigrationHero-module--grid-span-9-7--hNeOC";
export var gridSpan98 = "MigrationHero-module--grid-span-9-8--6aes7";
export var gridSpan99 = "MigrationHero-module--grid-span-9-9--Z+YhS";
export var textBreak = "MigrationHero-module--text-break--q9Y6x";